<div class="main-wrapper" [ngClass]="{ dark: darkTheme }" >
  <router-outlet></router-outlet>
  <app-layout ></app-layout>
</div>
